<template>
  <!-- https://www.npmjs.com/package/vue-tinymce-editor -->
  <!-- https://stackoverflow.com/questions/16033321/remove-menu-and-status-bars-in-tinymce-4 -->
  <!-- <div> -->
    <!-- v-model="data" -->
    <!-- :ref="'tinymce_'+id" -->
  <tinymce
    :id="id"
    :value="value"
    ref="editor"
    @input="$emit('input', $event)"
    @editorInit="initdEditor"
    style="width: 100%; margin-top: 1px;"
    class="elevation-0"
    toolbar1="formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | image media print code removeformat fullscreen"
    :plugins="[
      'advlist autolink lists link image charmap print preview hr anchor pagebreak',
      'searchreplace wordcount visualblocks visualchars code fullscreen',
      'insertdatetime media nonbreaking table contextmenu directionality',
      'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']"
    :other_options="{

      height: height, // 높이지정

      menubar: false,  // 메뉴바 감추기
      statusbar: true, // 상태바 감추기

      language_url: '/front/tinymce/langs/ko_KR.js', // 한글로 나오게. https://www.tiny.cloud/get-tiny/language-packages/ 에서 다운받아서 추가함.

      // 엔터치면 br ( 3개 옵션 다 필요 )
      force_br_newlines : true,
      force_p_newlines  : false,
      forced_root_block : '',

      paste_data_images: true,

      content_css : '/front/tinymce/editor.css',
    }"
  />
  <!-- <s-code v-text="data"></xmp>
  </div> -->
</template>

<style>
.mce-tinymce.mce-container.mce-panel { border: none !important; }
.mce-btn { border: none !important; }
.mce-edit-area { border: none !important; }

.mce-content-body { font-size: 12px; }
</style>


<script>
import InputSet from './mixin/input-set';
export default {
  props: ['height', 'data', 'id', 'value', 'keyBind'],
  mixins: [ InputSet ],
  methods: {

    downKey(e) {
      // console.log("다운키", e)
      this.$emit('downKey', e.keyName, e)

    },

    initdEditor(editor) {

      this.value && editor.setContent(this.value); // 보통때는 필요 없으나 개발모드에서 페이지 업데이트시 값이 날라가는 증상이 있음. 그래서 이 코드가 필요.

      // editor.onKeyDown.add(function onkeydown(ed, evt) {
      const self = this

      editor.on('keydown', function(evt) {
        // console.log("evt", evt)
        // F1 ~ F11 또는 Ctrl+S 인 경우만 처리
        if ((!evt.altKey && !evt.shiftKey &&  evt.ctrlKey && !evt.metaKey && evt.keyCode == 83) // ctrl + s
          ||(!evt.altKey && !evt.shiftKey && !evt.ctrlKey && !evt.metaKey && 112 <= evt.keyCode && evt.keyCode <= 122)) { // F1 - F11

          // ctrl+s 또는 f1, f2, 이렇게 문장으로 만들자
          let keyName = ""
          if (evt.ctrlKey ) keyName += "ctrl+"
          if (evt.altKey  ) keyName += "alt+"
          if (evt.shiftKey) keyName += "shift+"
          keyName += evt.key.toLowerCase()

          // 키 맵에 등록된 경우에 콜백 실행
          // <s-editor id="e1" v-model="sitem.cont" :keyBind="{'f7' : doSearch, 'ctrl+s' : saveItem}" />
          const func = self.keyBind && self.keyBind[keyName]
          if (func) {
            setTimeout(()=>func(keyName), 1);
            return false // 해당키가 있으면 이미 눌린건 무효화
          }

          // let e = { type : 'keydown'};
          // e.charCode = evt.charCode
          // e.keyCode  = evt.keyCode
          // e.which    = evt.which

          // e.shiftKey = evt.shiftKey
          // e.altKey   = evt.altKey
          // e.ctrlKey  = evt.ctrlKey
          // e.metaKey  = evt.metaKey

          // e.keyName  = keyName

          // // console.log("evt", evt)
          // // console.log("e", e)

          // // setTimeout(()=>window.parent && window.parent.receiveShortCutEvent && window.parent.receiveShortCutEvent(e), 1);
          // setTimeout(()=>self.downKey(e), 1);
        }

        return true // 눌린키 유효화
      });

      // editor.shortcuts.add("alt+t", "Show Me My Content", function() {
      //   alert(editor.getContent())
      // })
      // editor.shortcuts.add("ctrl+i", "Show Me My Content", function() {
      //   alert(editor.getContent())
      // })

      // let ed = editor

      // ed.onKeyDown.add(function onkeydown(ed, evt) {
      // // Shortcut: ctrl+h
      // if (evt.keyCode == 72 && !evt.altKey && !evt.shiftKey && evt.ctrlKey && !evt.metaKey) {
      // setTimeout(function(){
      // var e = { type : 'keydown'};
      // e.charCode = e.keyCode = e.which = 72;
      // e.shiftKey = e.altKey = e.metaKey = false;
      // e.ctrlKey = true;
      // window.parent && window.parent.receiveShortCutEvent && window.parent.receiveShortCutEvent(e);
      // }, 1);
      // }
      // });

      // var ret = this.addShortcut('ctrl+s', '', function () {}); //just in case...
      // var ret = editor.shortcuts.add('ctrl+s', "description of the shortcut", function() {});
      // var ret = editor.shortcuts.remove('ctrl+s')
      // console.log("rr", ret)

      // editor.shortcuts.add('access+a', "description of the shortcut", function() {}); // "access" maps to ctrl+alt on Mac a
      // console.log("삭제1", editor.shortcuts.remove('ctrl+s')) // 단축키 삭제
      // editor.on("init", function(){
      //   console.log("삭제2", editor.shortcuts.remove('ctrl+s')) // 단축키 삭제
      //   editor.addShortcut("ctrl+u", "", "");
      // });
    },
  }
}




// import jQuery from "jquery";
// const $ = jQuery;
// window.$ = $;

// let w = window;
// let d = window.document;
// let b = window.document.body;

// window.receiveShortCutEvent = function (eventObject){
//   console.log('receiveShortCutEvent2', eventObject);

//   $(document).trigger(eventObject);
//   $(document).trigger({type: 'keydown', ctrlKey: eventObject.ctrlKey, altKey: eventObject.altKey, which: eventObject.keyCode, originalEvent:eventObject });

//   $(w).trigger(eventObject);
//   $(w).trigger({type: 'keydown', ctrlKey: eventObject.ctrlKey, altKey: eventObject.altKey, which: eventObject.keyCode, originalEvent:eventObject });


//   var keyboardEvent = d.createEvent("KeyboardEvent");
//   var initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? "initKeyboardEvent" : "initKeyEvent";
//   keyboardEvent[initMethod]("keypress", false, false, w,
//                     eventObject.ctrlKey ? 1 : 0, eventObject.altKey ? 1 : 0, eventObject.shiftKey ? 1 : 0, 0,
//                     eventObject.keyCode, eventObject.which)
//   console.log("kk", document.getElementById("kk"))
//   document.getElementById("kk").dispatchEvent(keyboardEvent);
//   document.getElementById("zz").dispatchEvent(keyboardEvent);
//   document.getElementById("ss").dispatchEvent(keyboardEvent);
//   document.dispatchEvent(keyboardEvent);
//   document.body.dispatchEvent(keyboardEvent);
//   window.dispatchEvent(keyboardEvent);

//   var e = $.Event("keydown");
//   e.which = eventObject.which;
//   e.keyCode = eventObject.keyCode;
//   $(w).trigger(e);
//   $(d).trigger(e);
//   $(b).trigger(e);
//   $(window).trigger(e);
//   $(document).trigger(e);
//   $(document.body).trigger(e);
//   $("#zz").trigger(e);
//   $("#kk").trigger(e);
//   // $(document).trigger(e);
//   console.log("e", e)
//   console.log("zz", $("#zz").innerHTML)
//   console.log("zz", document.getElementById("zz"))
//   // $(document.getElementById("zz")).trigger(e);
//   $("#zz").trigger(e);
//     return false;
// }


</script>
